// Shared visual constants used by both 2D plan and 3D model
export const KIND_COLORS_3D = {
  bedroom:  "#1e40af",
  bath:     "#0e7490",
  kitchen:  "#b45309",
  living:   "#475569",
  corridor: "#78716c",
  entry:    "#5b21b6",
  closet:   "#0f172a",
  sleep:    "#1e40af",
};

export const KIND_COLORS_2D = {
  bedroom:  "#1e3a8a",
  bath:     "#0e7490",
  kitchen:  "#92400e",
  living:   "#334155",
  corridor: "#57534e",
  entry:    "#4c1d95",
  closet:   "#0b1220",
  sleep:    "#1e3a8a",
};

/**
 * Transform a room (in unit-local coords) into world/plan coords given the unit instance.
 * Coordinate system: x = along building length, z = depth (front-to-back).
 * unit-local: roomX = x along length, roomY = y along depth (0..8ft)
 * If mirrored, flip along length axis. Rotation supports 0 or 180 (we only use these here).
 */
export function placeRoom(unit, unitType, room) {
  const L = unitType.length_ft;
  const D = unitType.depth_ft;
  let rx = room.x;
  let ry = room.y;
  let rw = room.w;
  let rh = room.h;

  if (unit.mirrored) {
    rx = L - room.x - room.w;
  }
  if (unit.rotation === 180) {
    ry = D - room.y - room.h;
  }
  return {
    x: unit.x + rx,
    z: unit.z + ry,
    w: rw,
    d: rh,
  };
}

export function placeDoor(unit, unitType, door) {
  const L = unitType.length_ft;
  const D = unitType.depth_ft;
  let side = door.side;
  let pos = door.pos;
  if (unit.mirrored && (side === "bottom" || side === "top")) {
    pos = L - pos;
  }
  if (unit.rotation === 180) {
    if (side === "bottom") side = "top";
    else if (side === "top") side = "bottom";
  }
  // Calculate door position in world coords
  let x, z;
  if (side === "bottom") { x = unit.x + pos; z = unit.z + D; }
  else if (side === "top") { x = unit.x + pos; z = unit.z; }
  else if (side === "left") { x = unit.x; z = unit.z + pos; }
  else { x = unit.x + L; z = unit.z + pos; }
  return { x, z, side, width: door.width, kind: door.kind };
}
